import React from "react";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../components/CustomButton";
import { ClientProfile } from "../../../interfaces/common";
import PencilIcon from "../../../components/Icons/PencilIcon";

interface Props {
  profile: ClientProfile;
  changeStep: Function;
}

const StepSix: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const displayCoachingExperience = (value: number) => {
    if (value === 3) {
      return t("vast-experience");
    } else if (value === 2) {
      return t("moderate-experience");
    } else if (value === 1) {
      return t("little-experience");
    } else if (value === 0) {
      return t("no-experience");
    }
    return "Unknown " + value;
  };

  const displayLanguages = (languages: Array<string>) => {
    let languageString = "";
    let i = 0;
    for (const l of languages) {
      if (i > 0) languageString += ", ";
      languageString += t("language_" + l);
      i++;
    }
    return languageString;
  };

  return (
    <>
      <div className="mt-6 z-heading2">{t("summary")}</div>

      <div className="mt-6 flex items-center">
        <div className="z-title1">{t("professional-details")}</div>
        <CustomButton
          buttonType="transparentBase"
          className="ml-1"
          onClick={() => props.changeStep(0)}
          size="sm"
          isRound={true}
          leftIcon={<PencilIcon variant="white" alt="Info" className="w-4 h-4" />}
        ></CustomButton>
      </div>

      <div className="mt-2 flex justify-between text-gray-400">
        <div className="font-medium">{t("title-role")}</div>
        <div>{props.profile.title}</div>
      </div>
      <div className="mt-2 flex justify-between text-gray-400">
        <div className="font-medium">{t("select-leadership-level")}</div>
        <div>{t(props.profile.leadershipLevel)}</div>
      </div>
      <div className="mt-2 flex justify-between text-gray-400">
        <div className="font-medium">{t("in-company-since")}</div>
        <div>{props.profile.inCompanySince}</div>
      </div>
      <div className="mt-2 flex justify-between text-gray-400">
        <div className="font-medium">{t("current-role-since")}</div>
        <div>{props.profile.currentRoleSince}</div>
      </div>

      <hr className="mt-4 border-indigo-700" />

      <div className="mt-6 flex items-center">
        <div className="z-title1">{t("coach-experience-title")}</div>
        <CustomButton
          buttonType="transparentBase"
          className="ml-1"
          onClick={() => props.changeStep(1)}
          size="sm"
          isRound={true}
          leftIcon={<PencilIcon variant="white" alt="Info" className="w-4 h-4" />}
        ></CustomButton>
      </div>
      <div className="mt-2 text-gray-400">
        {displayCoachingExperience(props.profile.coachingExperience)}
      </div>

      <hr className="mt-4 border-indigo-700" />
      <div className="mt-6 flex items-center">
        <div className="z-title1">{t("languages")}</div>
        <CustomButton
          buttonType="transparentBase"
          className="ml-1"
          onClick={() => props.changeStep(2)}
          size="sm"
          isRound={true}
          leftIcon={<PencilIcon variant="white" alt="Info" className="w-4 h-4" />}
        ></CustomButton>
      </div>
      <div className="mt-2 flex justify-between text-gray-400">
        {displayLanguages(props.profile.languagesProfessional)}
      </div>

      <hr className="mt-4 border-indigo-700" />

      <div className="mt-6 flex items-center">
        <div className="z-title1">{t("coachingAreas")}</div>
        <CustomButton
          buttonType="transparentBase"
          className="ml-1"
          onClick={() => props.changeStep(3)}
          size="sm"
          isRound={true}
          leftIcon={<PencilIcon variant="white" alt="Info" className="w-4 h-4" />}
        ></CustomButton>
      </div>
      {props.profile.coachingAreas.map((area, index) => (
        <div className="mt-2 text-gray-400" key={"area_" + index}>
          {t(area)}
        </div>
      ))}

      <hr className="mt-4 border-indigo-700" />

      <div className="mt-6 flex items-center">
        <div className="z-title1">
          {t("coach-industry-experience")}
        </div>
        <CustomButton
          buttonType="transparentBase"
          className="ml-1"
          onClick={() => props.changeStep(4)}
          size="sm"
          isRound={true}
          leftIcon={<PencilIcon variant="white" alt="Info" className="w-4 h-4" />}
        ></CustomButton>
      </div>
      {props.profile.coachIndustryExperiences.map((area, index) => (
        <div className="mt-2 text-gray-400" key={"ind_" + index}>
          {t(area)}
        </div>
      ))}

      <hr className="mt-4 border-indigo-700" />

      {props.profile.coachId !== "0" ? (
        <p className="mt-6">
          You have already selected a coach. If you want to change coach, please
          contact support@zebrain.se
        </p>
      ) : (
        <CustomButton className="mt-6" onClick={() => props.changeStep(6)}>
          {t("submit-for-matching")}
        </CustomButton>
      )}
    </>
  );
};

export default StepSix;
